import React from 'react';

export const ArrowIcon: React.FC<{
  type?: 'arrow' | 'triangle';
  color?: string;
}> = ({ type = 'arrow', color = '#E4E4E4' }) => {
  if (type === 'triangle')
    return (
      <svg
        width="6"
        height="5"
        viewBox="0 0 6 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.666646 0.666656L5.33331 0.666656L2.99998 4.33332L0.666646 0.666656Z"
          fill={color}
        />
      </svg>
    );

  if (type === 'arrow')
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12L0 6L6 0L7.06875 1.05L2.86875 5.25H12V6.75H2.86875L7.06875 10.95L6 12Z"
          fill="#E4E4E4"
        />
      </svg>
    );
};
